import {gql} from "@apollo/client";
import {MissingDocumentationInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthMissingDocumentation($input: MissingDocumentationInput) {
    submitAuthMissingDocumentation(input: $input) {
        guid
    }
}`;

type AuthMissingDocumentationInput = MissingDocumentationInput & {
    authorizationGuid: string;
}

export function useAuthMissingDocumentation(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthMissingDocumentationInput }, void>(GRAPHQL_MUTATION);
    const submitMissingDocumentation = useCallback(async function (formValues: MissingDocumentationInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'Missing documentation request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitMissingDocumentation
    }
}
